module.exports = __webpack_public_path__ + "static/media/hvPremium.f06ed457.jpeg";